export default "__VITE_ASSET__CeeLO0ib__"